import request from "./request"

export function getDiscoverConfig() {
  return request({ url: "/discover/config_get", method: "get" })
}

export function getDiscoverFeatured() {
  return request({ url: "/discover/featured_get", method: "get" })
}

export function getDramaCategories() {
  return request({ url: "/discover/drama_category_list_get", method: "get" })
}

export function getDramaList(params) {
  return request({ url: "/discover/drama_list_get", method: "get", params })
}

export function getDramaDetail(params) {
  return request({ url: "/discover/drama_detail_get", method: "get", params })
}

export function getDramaPlay(params) {
  return request({ url: "/discover/drama_play_get", method: "get", params })
}

export function updateDramaProgress(data) {
  return request({ url: "/discover/drama_progress_update", method: "post", data })
}

export function getNovelCategories() {
  return request({ url: "/discover/novel_category_list_get", method: "get" })
}

export function getNovelList(params) {
  return request({ url: "/discover/novel_list_get", method: "get", params })
}

export function getNovelDetail(params) {
  return request({ url: "/discover/novel_detail_get", method: "get", params })
}

export function getNovelChapters(params) {
  return request({ url: "/discover/novel_chapter_list_get", method: "get", params })
}

export function getNovelChapter(params) {
  return request({ url: "/discover/novel_chapter_get", method: "get", params })
}

export function updateNovelProgress(data) {
  return request({ url: "/discover/novel_progress_update", method: "post", data })
}

export function updateNovelAudioProgress(data) {
  return request({ url: "/discover/novel_audio_progress_update", method: "post", data })
}

export function getMusicCategories() {
  return request({ url: "/discover/music_category_list_get", method: "get" })
}

export function getMusicList(params) {
  return request({ url: "/discover/music_list_get", method: "get", params })
}

export function getMusicDetail(params) {
  return request({ url: "/discover/music_detail_get", method: "get", params })
}

export function getMusicPlay(params) {
  return request({ url: "/discover/music_play_get", method: "get", params })
}

export function updateMusicProgress(data) {
  return request({ url: "/discover/music_progress_update", method: "post", data })
}

export function updateMusicFavorite(data) {
  return request({ url: "/discover/music_favorite_update", method: "post", data })
}

export function getGameCategories() {
  return request({ url: "/discover/game_category_list_get", method: "get" })
}

export function getGameList(params) {
  return request({ url: "/discover/game_list_get", method: "get", params })
}

export function getGameDetail(params) {
  return request({ url: "/discover/game_detail_get", method: "get", params })
}

export function getGameStart(params) {
  return request({ url: "/discover/game_start_get", method: "get", params })
}

export function updateGameProgress(data) {
  return request({ url: "/discover/game_progress_update", method: "post", data })
}

export function updateGameFavorite(data) {
  return request({ url: "/discover/game_favorite_update", method: "post", data })
}

export function getContinueList(params) {
  return request({ url: "/discover/continue_list_get", method: "get", params })
}

export function deleteContinueItem(data) {
  return request({ url: "/discover/continue_delete", method: "post", data })
}

export function clearContinueList() {
  return request({ url: "/discover/continue_clear", method: "post" })
}

export function getBookshelfList(params) {
  return request({ url: "/discover/bookshelf_list_get", method: "get", params })
}

export function getFavoriteList(params) {
  return request({ url: "/discover/favorite_list_get", method: "get", params })
}

export function updateBookshelf(data) {
  return request({ url: "/discover/bookshelf_update", method: "post", data })
}

export function getRanking(params) {
  return request({ url: "/discover/ranking_get", method: "get", params })
}

export function searchDiscover(params) {
  return request({ url: "/discover/search_get", method: "get", params })
}

export function addDiscoveryFeedback(data) {
  return request({ url: "/discover/feedback_add", method: "post", data })
}

export function addDiscoveryEvent(data) {
  return request({ url: "/discover/event_add", method: "post", data })
}
